export default __webpack_public_path__ + "static/media/dutgo-screenshot-05.b9b33a93.png";